import { configureStore } from '@reduxjs/toolkit';
import { caseOverviewDataReducer } from '../features/analysis/logic/caseOverviewDataSlice'
import { caseInfoDataReducer } from '../features/caseinfo/logic/Slice';
import { useDispatch, useSelector } from 'react-redux';
import { configsReducer } from '../features/configs/logic/Slice';
import { caseFiltersReducer } from '../features/cases/logic/CaseFiltersSlice';
import { caseCreationReducer } from '../features/cases/logic/CaseCreationSlice';
import { caseListReducer } from '../features/cases/logic/CaseListSlice';
import { portfolioAnalysisDataReducer } from '../features/analysis/logic/portfolioAnalysisSlice';
import { additionalAnalysisReducer } from '../features/analysis/logic/additionalAnalysisSlice';
import { interviewAnalysisReducer } from '../features/analysis/logic/InterviewAnalysisSlice';
import { caseNotesDataReducer } from '../features/remarks/logic/CaseNotesSlice';
import { recommendationsReducer} from '../features/recommendations/logic/Slice'
import { observationsReducer } from '../features/observations/logic/Slice';
import { userActionStatusReducer } from '../features/userActionsStatus/logic/userActionsStatusSlice';
import { reportsReducer } from '../features/reporting/logic/reportsSlice';
import { partiesInvolvedReducer } from '../features/partiesinvolved/logic/PartiesInvolvedSlice';
import { aiInsightsReducer } from '../features/aiInsights/logic/aiInsightsSlice';
import { caseDocumentsReducer } from '../features/documentManagement/logic/caseDocumentsSlice';
import { caseEventsReducer } from '../features/timeline/logic/slice';
import { recoveryReducer } from '../features/reporting/logic/recoverySlice';
import { leaReportsReducer } from "../features/reporting/logic/leaSlice";
import { dashboardReducer } from "../features/dashboard/logic/dashboardSlice";
import { fmr1Reducer } from "../features/reporting/logic/frm1Slice";
import { verificationsReducer } from '../features/analysis/logic/verifications/verificationSlice';
import { commentsReducer } from "../features/comments/logic/commentsSlice";
import { usersReducer } from '../features/users/logic/slice';
import { preSCNFicreducer } from '../features/reporting/components/preScnFIC/logic/PreSCNFicSlice';
import { caseStageConfigReducer } from '../features/caseStages/logic/slice';
import { observationsByAuthorityReducer } from '../features/reporting/components/ObservationsByAuthority/logic/ObservationsByAuthoritySlice';
import { participantReducer } from '../features/caseinfo/logic/ParticipantsSlice';
import { finalFICReducer } from '../features/reporting/ficDecision/logic/slice';
import { policyImprovementsReducer } from '../features/recommendations/logic/PolicyImprovementsSlice';
import { actionsAgainstPerpetratorsReducer } from '../features/recommendations/logic/ActionsAgainstPerpetratorsSlice';
import { scnReportsReducer } from '../features/reporting/components/scn/logic/scnReportsSlice';
import { scnResponseReportsReducer } from '../features/reporting/components/scn/logic/scnResponseReportsSlice';
import { roReducer } from '../features/reporting/components/ro/logic/slice';
import { borrowalVsNonBorrowalReportReducer } from '../features/TenantReports/logic/borrowalVsNonBorrowalReportSlice';
import { fraudByFicCategoryReportReducer } from '../features/TenantReports/logic/fraudByFicCategoryReportSlice';
import { assetsReducer } from '../features/legalTechnicalAnalysis/Logic/assetsSlice';
import { chargesReducer } from '../features/legalTechnicalAnalysis/Logic/chargesSlice';
import { fraudElementsReducer } from '../features/fraudElements/logic/fraudElementsSlice';
import { formConfigsReducer } from '../features/legalTechnicalAnalysis/Logic/formConfigsSlice';
import { physicalTechnicalVerificationsReducer } from '../features/legalTechnicalAnalysis/Logic/physicalTechnicalVerificationSlice';
import { legalVerificationsReducer } from '../features/legalTechnicalAnalysis/Logic/legalVerificationSlice';
import { verificationsReducer as verificationsV2Reducer } from '../features/customerVerifications/Logic/verificationsSlice';
import { creditAccountsReducer } from '../features/creditAccounts/logic/slice';
import { accountsReducer } from '../features/accounts/logic/slice';
import { disbursementsReducer } from "../features/disbursements/Logic/disbursementsSlice";
import { sanctionEventsReducer } from "../features/sanctionEvents/Logic/sanctionEventsSlice";
import { stakeholdersReducer } from '../features/stakeholder/logic/stakeholderSlice';
import { branchDetailsReducer } from '../features/branchDetails/logic/branchDetailsSlice';
import { incidentDetectionLapseReviewReducer } from '../features/incidentDetectionLapseReview/logic/slice';
import { caseAuditsReducer } from '../features/otherAudits/logic/slice';



export const store = configureStore({
  reducer: {
    // Add reducers here
    configs: configsReducer,
    users: usersReducer,
    caseStageConfigs: caseStageConfigReducer,
    caseFilters: caseFiltersReducer,
    caseCreation: caseCreationReducer,
    caseList: caseListReducer,
    caseOverviewData: caseOverviewDataReducer,
    caseInfoData: caseInfoDataReducer,
    participants: participantReducer,
    caseDocuments: caseDocumentsReducer,
    portfolioAnalysisData: portfolioAnalysisDataReducer,
    additionalAnalysisData: additionalAnalysisReducer,
    interviewAnalysis: interviewAnalysisReducer,
    caseNotesData: caseNotesDataReducer,
    recommendationsData: recommendationsReducer,
    policyImprovementsData: policyImprovementsReducer,
    actionsAgainstPerpetratorsData: actionsAgainstPerpetratorsReducer,
    observationsData: observationsReducer,
    userActionsStatusData: userActionStatusReducer,
    reportsData: reportsReducer,
    leaReportsData: leaReportsReducer,
    commentsData: commentsReducer,
    fmr1Data: fmr1Reducer,
    preSCNFic: preSCNFicreducer,
    fic: finalFICReducer,
    ro: roReducer,
    partiesInvolvedData: partiesInvolvedReducer,
    insightsData: aiInsightsReducer,
    eventsData: caseEventsReducer,
    recoveryData: recoveryReducer,
    dashboardData: dashboardReducer,
    verificationsData: verificationsReducer,
    fraudElements: fraudElementsReducer,
    assets: assetsReducer,
    charges: chargesReducer,
    formConfigs: formConfigsReducer,
    physicalTechnicalVerifications: physicalTechnicalVerificationsReducer,
    legalVerifications: legalVerificationsReducer,
    observationsByAuthority: observationsByAuthorityReducer,
    scnReports: scnReportsReducer,
    scnResponseReports: scnResponseReportsReducer,
    borrowalVsNonBorrowalReportData: borrowalVsNonBorrowalReportReducer,
    fraudByFicCategoryReportData: fraudByFicCategoryReportReducer,
    creditAccounts: creditAccountsReducer,
    accounts: accountsReducer,
    stakeholders: stakeholdersReducer,
    branchDetails: branchDetailsReducer,
    disbursements: disbursementsReducer,
    sanctionEvents: sanctionEventsReducer,
    verifications: verificationsV2Reducer,
    incidentDetectionLapseReview: incidentDetectionLapseReviewReducer,
    caseAudits: caseAuditsReducer,
  },
});

// RootState represents the type of the entire Redux store state. It captures
// the structure of all combined reducers.
export type RootState = ReturnType<typeof store.getState>;


// AppDispatch represents the type of the store's dispatch function, including
// any middleware applied. For thunks and other async middleware, as AppDispatch
// correctly types the return values of async actions
// 
// Used for 
// - type safe dispatching of actions
// - useDispatch hook
// - creating a pre-typed useDispatch hook (custom hooks)
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()